import {
  createThis2j2avj17cvnv2 as createThis,
  toString1pkumu07cwy4m as toString,
} from '../js/coreRuntime.mjs';
import {
  IndexOutOfBoundsException1qfr429iumro0 as IndexOutOfBoundsException,
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
} from '../exceptions.mjs';
import {
  charSequenceGet1vxk1y5n17t1z as charSequenceGet,
  charSequenceLength3278n89t01tmv as charSequenceLength,
} from '../js/charSequenceJs.mjs';
import {
  substringiqarkczpya5m as substring,
  substring3saq8ornu0luv as substring_0,
} from './stringJs.mjs';
import {
  toString22rbkbhdb5cl2 as toString_0,
  _Char___init__impl__6a9atx2gndcvjvc5pke as _Char___init__impl__6a9atx,
} from '../Char.mjs';
import { toString30pk9tzaqopn as toString_1 } from '../Library.mjs';
import { Companion_instance23tt71mgnug0i as Companion_instance } from '../collections/AbstractList.mjs';
import { CharSequence1ceii1xorfwh7 as CharSequence } from '../CharSequence.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var StringBuilderClass;
function StringBuilder() {
  if (StringBuilderClass === VOID) {
    class $ {
      static ng(content) {
        var $this = createThis(this);
        $this.k1_1 = content;
        return $this;
      }
      static tb(capacity) {
        return this.l1();
      }
      static l1() {
        return this.ng('');
      }
      a() {
        // Inline function 'kotlin.js.asDynamic' call
        return this.k1_1.length;
      }
      b(index) {
        // Inline function 'kotlin.text.getOrElse' call
        var this_0 = this.k1_1;
        var tmp;
        if (0 <= index ? index <= (charSequenceLength(this_0) - 1 | 0) : false) {
          tmp = charSequenceGet(this_0, index);
        } else {
          throw IndexOutOfBoundsException().i3('index: ' + index + ', length: ' + this.a() + '}');
        }
        return tmp;
      }
      c(startIndex, endIndex) {
        return substring(this.k1_1, startIndex, endIndex);
      }
      o1(value) {
        this.k1_1 = this.k1_1 + toString_0(value);
        return this;
      }
      o2(value) {
        this.k1_1 = this.k1_1 + toString_1(value);
        return this;
      }
      og(value, startIndex, endIndex) {
        return this.pg(value == null ? 'null' : value, startIndex, endIndex);
      }
      s1(value) {
        this.k1_1 = this.k1_1 + toString_1(value);
        return this;
      }
      qg(value) {
        this.k1_1 = this.k1_1 + value;
        return this;
      }
      rg(value) {
        return this.m1(value.toString());
      }
      sg(value) {
        return this.m1(value.toString());
      }
      m1(value) {
        var tmp = this;
        var tmp_0 = this.k1_1;
        tmp.k1_1 = tmp_0 + (value == null ? 'null' : value);
        return this;
      }
      tg(index, value) {
        Companion_instance.z6(index, this.a());
        this.k1_1 = substring(this.k1_1, 0, index) + toString_0(value) + substring_0(this.k1_1, index);
        return this;
      }
      ug(newLength) {
        if (newLength < 0) {
          throw IllegalArgumentException().n2('Negative new length: ' + newLength + '.');
        }
        if (newLength <= this.a()) {
          this.k1_1 = substring(this.k1_1, 0, newLength);
        } else {
          var inductionVariable = this.a();
          if (inductionVariable < newLength)
            do {
              var i = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              this.k1_1 = this.k1_1 + toString_0(_Char___init__impl__6a9atx(0));
            }
             while (inductionVariable < newLength);
        }
      }
      toString() {
        return this.k1_1;
      }
      vg() {
        this.k1_1 = '';
        return this;
      }
      wg(index) {
        Companion_instance.i7(index, this.a());
        this.k1_1 = substring(this.k1_1, 0, index) + substring_0(this.k1_1, index + 1 | 0);
        return this;
      }
      pg(value, startIndex, endIndex) {
        var stringCsq = toString(value);
        Companion_instance.xg(startIndex, endIndex, stringCsq.length);
        this.k1_1 = this.k1_1 + substring(stringCsq, startIndex, endIndex);
        return this;
      }
    }
    initMetadataForClass($, 'StringBuilder', $.l1, VOID, [CharSequence()]);
    StringBuilderClass = $;
  }
  return StringBuilderClass;
}
//region block: exports
export {
  StringBuilder as StringBuildermazzzhj6kkai,
};
//endregion

//# sourceMappingURL=StringBuilderJs.mjs.map
